export default "__VITE_ASSET__3079fd19__"